import { Injectable } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * ErrorStateMatcher that shows errors immediately when the control is invalid,
 * without waiting for touched or submitted state.
 *
 * Usage: Provide at component level to affect all mat-form-fields within that component.
 *
 * @example
 * ```typescript
 * @Component({
 *   providers: [
 *     { provide: ErrorStateMatcher, useClass: ImmediateErrorStateMatcher }
 *   ]
 * })
 * ```
 */
@Injectable()
export class ImmediateErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ImmediateErrorStateMatcherProvider implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid);
  }
}
